import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetErpPartDataList } from '@/api/DnbarcodeHandmade';
import util from '@/libs/util';
export default {
  computed: {
    selectRowsId: function selectRowsId() {
      return this.selectedTableData.map(function (item) {
        return item.id;
      });
    }
  },
  props: {
    isShowChangeMaterialDialog: {
      type: Boolean,
      default: false
    },
    VENDOR_CODE: {
      type: String,
      default: ''
    },
    selectedTableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      loading: false,
      pageInfo: {
        TotalCount: null,
        Page: 1,
        Limit: 10
      },
      PART_NO: null
    };
  },
  methods: {
    // 清空
    handleClear: function handleClear() {
      this.PART_NO = null;
      this.GetMeterList();
    },
    // 搜索
    handleSeach: function handleSeach() {
      this.GetMeterList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.pageInfo.Page = value;
      this.GetMeterList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.pageInfo.Limit = value;
      this.GetMeterList();
    },
    // 选择行
    currentChange: function currentChange(_ref) {
      var newValue = _ref.newValue,
          oldValue = _ref.oldValue,
          row = _ref.row,
          rowIndex = _ref.rowIndex,
          $rowIndex = _ref.$rowIndex,
          column = _ref.column,
          columnIndex = _ref.columnIndex,
          $columnIndex = _ref.$columnIndex,
          $event = _ref.$event;
      // console.log(row);
      // console.log(rowIndex);
      // console.log($rowIndex);
      this.$refs.xTable.toggleCheckboxRow(this.tabelData[rowIndex]);
    },
    // 行样式
    rowClassName: function rowClassName() {
      return 'rowClass';
    },
    GetMeterList: function GetMeterList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('选中的',this.selectedTableData);
                params = {
                  VENDOR_CODE: _this.VENDOR_CODE,
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  Page: _this.pageInfo.Page,
                  Limit: _this.pageInfo.Limit,
                  PART_NO: _this.PART_NO
                };
                _this.loading = true;
                _context.next = 4;
                return GetErpPartDataList(params);

              case 4:
                res = _context.sent;
                console.log(res);
                _this.loading = false;

                if (res.code === 0) {
                  _this.tabelData = res.data.Items;
                  _this.pageInfo.TotalCount = res.data.TotalCount;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleCancel: function handleCancel() {
      this.$emit('closeChangeMaterialDialog', false);
    },
    handleDelSubmit: function handleDelSubmit() {
      var selectRecords = this.$refs.xTable.getCheckboxRecords(); // console.log('selectRecords',selectRecords);

      this.$emit('cbDialogSubmit', selectRecords);
      this.$emit('closeChangeMaterialDialog', false);
    }
  }
};